module.exports = __webpack_public_path__ + "img/fashion_22.be78cf15.jpg";